
















































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
import ImageSelector from '@/components/ImageSelector.vue';
import S3Image from '@/components/S3Image.vue';
import VideoSelector from '@/components/VideoSelector.vue';

@Component({
  components: {VideoSelector, S3Image, ImageSelector},
})
export default class DlgPostsNewMobile extends Vue {
  public $refs!: {
    form: any,
  };

  @Action('moderator/posts/create') private createPost!: any;
  @Action('moderator/posts/read') private readPosts!: any;
  @Action('moderator/animals/read') private readAnimals!: any;
  @Action('moderator/posts/uploadImage') private uploadImage!: any;
  @Action('moderator/posts/uploadVideo') private uploadVideo!: any;
  @Getter('common/rules/all') private rules!: any;
  @Getter('moderator/animals/all') private animals!: any;

  private post: any = {};
  private postImage: any = null;
  private postFile: any = null;
  private dialog: boolean = false;
  private loading: boolean = false;
  private valid: boolean = true;
  private selected: string = '';
  private e1: number = 1;

  @Watch('dialog')
  private async changedDialogValue(val: boolean) {
    if (val) {
      this.loading = true;
      await this.readAnimals();
      this.loading = false;
    }
  }

  private async save() {
    if (this.$refs.form.validate() && this.selected) {
      this.loading = true;

      this.post.animalId = this.selected;
      if (this.postImage) {
        this.post.images = [await this.uploadImage({animalId: this.post.animalId, image: this.postImage})];
      } else if (this.postFile) {
        this.post.video = await this.uploadVideo({animalId: this.post.animalId, video: this.postFile});
      }

      this.createPost(this.post)
        .then((success: any) => {
          if (success) {
            return this.readPosts();
          }
          throw new Error();
        })
        .then(() => {
          this.loading = false;
          this.dialog = false;
          this.post = {};
          this.postImage = null;
          this.selected = '';
          this.e1 = 1;
          this.$refs.form.resetValidation();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }

  private selectAnimal(animal) {
    this.selected = animal.id;
    this.e1 = 2;
  }
}
